<template id="question-payment-setup">
    <li>
        <!-- <div class="info">question-payment-setup</div> -->
        <div v-html="question" class="question"></div>
        <div class="btn-container">
            <button :id="'btn_'+lowerize(choice)" class="iconbutton alternative-width" v-for="( choice, i ) in choices" :key="i" @click="updateValue( index, i )"
                :class="[ value==i ? 'active' : '' ]">
                <span class="icon" :class="icons[index][i]"></span>
                <div class="text">{{ choice }}</div>
            </button>
        </div>
    </li>
</template>


<script>
export default {
    template: '#question-payment-setup',

    
    props: ['question', 'event_category', 'index', 'choices', 'icons', 'event_labels', 'trackingclass', 'fare', 'payment', 'bill'],
    data: function () {
        return {
            value: -1
        };
    },

    created: function () {
        this.value = -1;
    },
    beforeMount: function () {
        this.value = -1;
    },

    mounted: function(){
        document.getElementById("btn_addebitodiretto").click();
        document.getElementById("btn_digitale").click();
    },

    methods: {

        updateValue: function (index, val) {
            console.log('updateValue', index, val);
            this.value = val;

            console.log('this.value payment setup ----> ', this.index, this.value);

            switch (this.index) {
                case 0:
                    if (this.value == 0) {
                        this.payment = "bollettino";
                    } else if (this.value == 1) {
                        this.payment = "addebito diretto";
                    }
                    console.log('pagamento ----> ', this.payment);
                    this.$emit('payment-setup-update', 'payment', this.payment);
                  break;
                case 1:
                    if (this.value == 0) {
                        this.bill = "cartaceo";
                    } else if (this.value == 1) {
                        this.bill = "digitale";
                    }
                    console.log('bolletta ----> ', this.bill);
                    this.$emit('payment-setup-update', 'bill', this.bill);
                break;
              } 
            
            this.trackClicks(this.event_labels[index][val], this.event_category);
            this.$emit('update-value', [index, val]);
        },

        lowerize: function (val) {
            val = val.toLowerCase().replace(/\s+/g, '');
            return val;
        },

        trackClicks: function( event_label, event_category ) {
            try {
                console.log( 'Route trackClicks event_label', event_label );
                console.log( 'Route trackClicks event_category', event_category );

                //- track analytics ---
                window.callDataLayer({ 
                    'event': "customEvent",
                    'eventAction': "carrello_step",                   
                    'eventLabel': event_label,
                    'eventCategory': event_category,
                });

                 console.log( 'QuestionPaymentSetup trackClicks --> after callDataLayer()');

                //- track content square ---
                //window._uxa = window._uxa || [];
                //window._uxa.push(['trackPageview', window.location.pathname+window.location.hash.replace('#','?__') + '?cs-offerta-link-luce-gas='+this.micro_step]);
            } catch (error) {
                // tracking is not ready
            }
        },
    }
}
</script>